<template>
  <section
    id="app"
    class="hero is-fullheight"
    :style="{ backgroundImage: `url(${backgroundUrl})` }"
  >
    <a class="logo-nav">
      <img class="logo" :src="logoUrl" alt="Zul Digital" />
    </a>
    <div class="hero-title">
      <h1 class="title">
        <span class="is-blue">Zul</span>
        <span class="is-blue">Digital</span>
        <span class="is-white">Corp</span>
      </h1>
      <p class="subtitle">Estacionamento Rotativo Digital</p>
    </div>
    <div class="hero-body">
      <b-loading
        :is-full-page="isFullPage"
        :active.sync="isLoading"
      ></b-loading>
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-half"></div>
          <div class="column is-half">
            <div class="columns is-centered">
              <div class="column is-8-desktop">
                <h1 class="title">Cadastre-se</h1>
                <h2 class="subtitle">
                  ou
                  <router-link to="/login">acesse sua conta</router-link>
                </h2>
                <RegisterPersonalStep
                  v-if="step === 'personal'"
                  @onConfirm="handlePersonalFormSubmit"
                />
                <RegisterPasswordStep
                  v-if="step === 'password'"
                  @onConfirm="handlePasswordConfirmationFormSubmit"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <OTPValidation
      :maskedPhoneNumber="maskedPhoneNumber"
      :userData="rawUserData"
      v-show="isOTPModalVisible"
      ref="otpValidation"
      @close="closeOTPModal"
    >
    </OTPValidation>
    <TermsModal ref="termsModal" @close="closeOTPModal" @onAccept="register" />
  </section>
</template>

<script>
import Vue from "vue";

import logoImage from "../../assets/images/logo.svg";
import background from "../../assets/images/login-bg.jpg";

import OTPValidation from "../../components/OTPValidation";

import RegisterPersonalStep from "./RegisterPersonalStep.vue";
import RegisterPasswordStep from "./RegisterPasswordStep.vue";

import TermsModal from "../../components/TermsModal.vue";

import user from "../../services/user";

export default {
  components: {
    OTPValidation,
    RegisterPersonalStep,
    RegisterPasswordStep,
    TermsModal,
  },
  computed: {
    logoUrl() {
      return logoImage;
    },
    backgroundUrl() {
      return background;
    },
  },
  data() {
    return {
      rawUserData: {},
      pinModel: "",
      maskedPhoneNumber: "",
      isOTPModalVisible: false,
      isFullPage: true,
      isLoading: false,
      user: {
        city: null,
        name: null,
        email: null,
        document: null,
        password: null,
        scope: "ROLE_CORPORATE_MASTER",
      },
      step: "personal",
    };
  },
  methods: {
    showOTPModal() {
      this.isOTPModalVisible = true;
    },
    closeOTPModal() {
      this.$nextTick(() => {
        this.isOTPModalVisible = false;
      });
    },
    handlePersonalFormSubmit(user) {
      this.user = {
        ...this.user,
        ...user,
      };

      this.step = "password";
    },
    handlePasswordConfirmationFormSubmit(user) {
      this.user = {
        ...this.user,
        ...user,
      };

      this.$refs.termsModal.open(this.user.city);
    },
    register() {
      const rawData = Object.assign(
        {
          acceptTermsOfUse: true,
        },
        this.user
      );
      const currentCity = rawData.city;

      rawData["city"] = undefined;

      localStorage.setItem("X-City", currentCity);

      this.isLoading = true;

      user
        .create(rawData, currentCity)
        .then((res) => {
          this.$auth.watch.authenticated = true;
          this.$auth.watch.loaded = true;
          this.$auth.user(res.data);

          this.$router.push("/");
        })
        .catch((error) => {
          const status = ((error || {}).response || {}).status;
          const message =
            (((error || {}).response || {}).data || {}).message ||
            "Algo inesperado aconteceu. Tente novamente mais tarde.";
          const data = ((error || {}).response || {}.data || {}.data || {})
            .data;

          const headers = ((error || {}).response || {}).headers || {};

          if (status === 409) {
            this.$buefy.toast.open({
              message: "Já existe um cadastro com os dados fornecidos.",
              type: "is-danger",
            });
          } else if (status === 426) {
            this.maskedPhoneNumber = (
              (data || {}).data || {}
            ).maskedPhoneNumber;

            Vue.auth.token("access_token", headers["x-auth-token"]);

            this.$refs.otpValidation.checkStep(this.maskedPhoneNumber, true);

            setTimeout(() => {
              this.showOTPModal();
            }, 150);
          } else {
            this.$buefy.toast.open({
              message,
              type: "is-danger",
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    validateAndSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          return this.register();
        }

        this.$buefy.toast.open({
          message: "Verfique os campos marcados para continuar.",
          type: "is-danger",
        });
      });
    },
  },
  // mounted() {
  //   this.$refs.termsModal.open()
  // }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/_variables.scss";

#app {
  background: $black;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;

  .is-blue {
    color: $blue;
  }
  .is-white {
    color: $white;
  }
}

.logo-nav {
  top: 100px;
  left: calc(100vw / 2 - 50px);
  position: fixed;

  @include desktop {
    top: 100px;
    left: 120px;
  }
}

.logo {
  height: 100px;
  width: 100px;
}

.title {
  font-weight: 900;

  > span {
    display: block;
  }
}

.hero-title {
  display: none;
  left: 24px;
  position: fixed;
  top: 50px;

  .title {
    font-size: 36px;
  }
  .subtitle {
    color: $white;
    font-size: 16px;
  }

  @include desktop {
    bottom: 100px;
    display: block;
    left: 120px;
    top: auto;

    .title {
      font-size: 72px;
    }

    .subtitle {
      font-size: 26px;
      margin-top: 30px;
    }
  }
}

h1,
h2,
h2 a {
  color: #fff;
}

h2 a {
  text-decoration: underline;
}
</style>
